module.exports = __webpack_public_path__ + "img/subscription-white.723380a3.svg";